////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> /?id=                             //
//                                                //
//  PÁGINA PARA VER TODOS OS PRODUTOS EM ESTOQUE. //
//  ESTA É A PÁGINA HOME.                         //
//                                                //
//  RECEBE COMO PARÂMETRO NA URL O ID             //
//  DA LOJA QUE ESTÁ VENDENDO OS PRODUTOS.        //
//                                                //
////////////////////////////////////////////////////  



import React, {useState} from "react"

import FiltroBotao from '../components/header/filtro_botao';
import Header from  '../components/header';
import Filtro from  '../components/filtro';
import Loader from  '../components/loader';
import ItensComprados from  '../components/itens_comprados';
import PrecoPicture from  '../components/preco_picture';

import api from "../services/api";


function Home() {

  // ESTADOS DEFINIDOS
    // 'produtos' = LISTA DE PRODUTOS
    // 'carrinho' = PRODUTOS NO CARRINHO COM DETALHES
    // 'prodscarrinho' = LISTA DE NOMES DOS PRODUTOS NO CARRINHO   
    // 'grupos' = LISTA DE TODOS OS GRUPOS DOS PRODUTOS   
    // 'favoritos' = LISTA DE PRODUTOS FAVORITADOS PELO USUÁRIO -> IMPLEMENTADO, PORÉM O ÍCONE DE FAVORITAR FOI RETIRADO DA TELA A PEDIDO DO DEPARTAMENTO DE MARKETING
    // 'botao' = BOOLEANO QUE DEFINE SE O BOTÃO DE CHECKOUT VAI APARECER OU NÃO

  let [produtos, setProdutos] = useState([])
  let [carrinho, setCarrinho] = useState([])
  let [prodscarrinho, setProdscarrinho] = useState([])
  let [grupos, setGrupos] = useState([])
  let [favoritos, setFavoritos] = useState([])
  let [botao, setBotao] = useState([])


  window.onload = function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DA PÁGINA '/?id='

    var params = window.location.search
    var urlparams = new URLSearchParams(params)
    var id = urlparams.get('id')

    sessionStorage.setItem('loja', id)  // COLOCA O ID DA LOJA NA SESSÃO

    if(sessionStorage['login']){  // CASO O USUÁRIO ESTEJA LOGADO

      if(sessionStorage['favoritar']){  // RETIRAR OS ITENS FAVORITADOS E NO CARRINHO DA SESSÃO (ELES VIRÃO DO DB)
        sessionStorage.removeItem('favoritar')
      }
      if(sessionStorage['comprar']){
        sessionStorage.removeItem('comprar')
      }
    }

    // CHAMAR A FUNÇÃO DE BUSCAR PRODUTOS COM OS PARÂMETROS DE FILTRO EM BRANCO
    search_produtos('{"grupo":"","preco_minimo":"","preco_maximo":"","ordem":"[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO"}', document.getElementById('filtro_por_texto').value)
  }  

  async function search_produtos(gruposquery, texto) {  // FUNÇÃO QUE BUSCA PRODUTOS
    // FUNÇÃO CHAMADA NO ONLOAD DESTA PÁGINA
    // FUNÇÃO CHAMADA AO CLICAR NO BOTÃO 'btn-filtro' DO COMPONENTE 'Filtro'
    // FUNÇÃO CHAMADA NA ALTERAÇÃO DO VALOR DE 'filtro_por_texto' DO COMPONENTE PESQUISAR

    // RECEBE COMO PARÂMETRO:
      // 'gruposquery' -> DICIONÁRIO COM FILTROS DE GRUPOS, PREÇO MÍNIMO, PREÇO MÁXIMO E ORDEM QUE DEVEM SER APLICADOS NA QUERY
      // 'texto' -> STRING COM O VALOR DO FILTRO GERAL NO HEADER 

    
    carrinho_de_compras()  // BUSCA OS ITENS DO CARRINHO DE COMPRAS
    
    let id_loja = sessionStorage['loja']  // DEFINE A LOJA
    
    var grupos = await api.post('buscar_grupo_produtos',{  // BUSCA NO DB OS GRUPOS DE PRODUTOS, O ESTOQUE DE SEGURANCA DA LOJA E SE A LOJA POSSUI CADASTRO NA PAGSEGURP
      "id_loja": id_loja,
    }).then((response) => {
      return response
    }) 
    // grupos['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
      // 'data' -> LISTA COM GRUPOS DOS PRODUTOS
        // CADA ITEM DE 'data' É UM STRING COM O NOME DE UM GRUPO DE PRODUTO
      
      // 'pag_seguro' -> BOOLEANO QUE MOSTRA SE A LOJA TEM CONTA NA PAGSEGURO
      
      // 'estoque_seguranca' -> INT COM O ESTOQUE DE SEGURANÇA DEFINIDO PARA A LOJA


    var estoque = grupos['data']['estoque_seguranca'] 

    setBotao(true)  // SEMPRE PERMITE CHECKOUT (REMOVIDA VERIFICAÇÃO PAGSEGURO)

    setGrupos(grupos.data.data)  // DEFINE O ESTADO DOS GRUPOS

    var query_start = 0  // INICIA A SUBQUERY EM ZERO
    var query_end = 25  // E REALIZA A BUSCA EM SUBQUERIES DE 25 PRODUTOS 
    var produtos_novo = [] // PRODUTOS INICIA COMO ZERADO


    // CHAMA A FUNÇÃO QUE REALIZA A BUSCA DOS PRIMEIROS ITENS NO DB (SEM DEPENDER DE SCROLL)
    var lista = await pega_proximos_produtos(id_loja, query_start, query_end, gruposquery, texto, estoque, produtos_novo) 

    query_start = lista[0]  // ATUALIZA OS PARÂMETROS DE SUBQUERY
    query_end = lista[1]
    produtos_novo = lista[2]
    
    if(query_start > query_end){  // CASO NÃO EXISTAM MAIS PRODUTOS
      document.getElementById('loader').classList.add('d-none')  // FAZ O LOADER DESAPARECER
    }
    
    
    var feito  = 0  // INDICA QUE NENHUMA REQUISIÇÃO FOI FEITA NESSA INTERRUPÇÃO DE ROLAGEM
    window.onscroll = async function() {  // NA ALTERAÇÃO DA BARRA DE ROLAGEM
      if(query_start > query_end){  // SE NÃO EXISTIREM MAIS PRODUTOS
        document.getElementById('loader').classList.add('d-none')  // SOME O LOADER
      }
      else{  //  SE AINDA EXISTIREM ITENS NO DB
        if(parseInt(document.scrollingElement.scrollTop + document.scrollingElement.clientHeight) > document.scrollingElement.scrollHeight - 2000){  // E A BARRA DE ROLAGEM ESTIVER PRÓXIMO AO FINAL DA PÁGINA
          if (feito == 0){  // E AINDA NÃO EXISITR REQUISIÇÃO NESSA INTERRUPÇÃO DE ROLAGEM
            feito = 1  // NÃO PERMITE MAIS REQUISIÇÕES NESSA INTERRUPÇÃO
            
            lista = await pega_proximos_produtos(id_loja, query_start, query_end, gruposquery, texto, estoque, produtos_novo)  // CHAMA A FUNÇÃO QUE BUSCA OS PRÓXIMOS ITENS DO DB
            query_start = lista[0]  // ATUALIZA OS PARÂMETROS DE SUBQUERY
            query_end = lista[1]        
            produtos_novo = lista[2]
            feito = 0  // PERMITE NOVA REQUISIÇÃO PARA BUSCAR OS PRÓXIMOS ITENS          
          }
        } 
        else{  // CASO O USUÁRIO NÃO ESTIVER PRÓXIMO AO FINAL DA TELA
          feito = 0  // PERMITE UMA NOVA REQUISIÇÃO QUANDO O USUÁRIO ROLAR A TELA PARA BAIXO
        }      
      } 
    }
  }  


  async function pega_proximos_produtos(id_loja, query_start, query_end, gruposquery, texto, estoque, produtos_novo){  // FUNÇÃO PARA PEGAR OS PRÓXIMOS 6 PRODUTOS
    // FUNÇÃO CHAMADA PELA FUNÇÃO 'search_produtos' DESTA PÁGINA
        
    console.log('novos produtos')
    var resp = await api.post('buscar_numero_itens',{  // BUSCA NO DB OS PRÓXIMOS 6 PRODUTOS COM BASE EM
      "id_loja": id_loja,                               // LOJA DO CATÁLOGO
      "query_start": query_start,                       // INÍCIO DA SUBQUERY
      "query_end": 25,                           // FINAL DA SUBQUERY
      "gruposquery": gruposquery,                       // DICIONARIO DE FILTROS
      "texto": texto,                                   // FILTRO GERAL DO HEADER
      "estoque": estoque,                               // ESTOQUE DE SEGURANÇA
    }).then((response) => {
      return response
    })
    // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
      // 'data' -> LISTA COM OS PRODUTOS
        // CADA ITEM DE 'data' É UM DICIONARIO COM AS CHAVES
          // 'id' -> STRING COM O ID DO PRODUTO
          // 'props' -> DICIONÁRIO COM AS CHAVES
            // 'detalhes' -> DICIONÁRIO COM AS CHAVES
              // 'DESC_COR_PRODUTO' -> STRING COM A COR DO PRODUTO
              // 'DESC_PRODUTO' -> STRING COM A DESCRIÇÃO DO PRODUTO
              // 'GRUPO_PRODUTO' -> STRING COM O GRUPO DO PRODUTO
              // 'TAMANHO' -> STRING COM O TAMANHO DO PRODUTO
            // 'estoque' -> INT COM QUANTOS ITENS DO PRODUTO AINDA RESTAM EM ESTOQUE
            // 'img' -> STRING COM A URL DA PRIMEIRA IMAGEM DO PRODUTO
            // 'preco' -> FLOAT COM O PREÇO ATUAL DO PRODUTO
            // 'preco_orig' -> FLOAT COM O PREÇO ORIGINAL DO PRODUTO

    // 'query_end' -> INT COM O VALOR DA POSIÇÃO DO FINAL DA SUBQUERY 
    
    
    query_start = (query_start + 25)  // DEFINE O COMEÇO DA PRÓXIMA SUBQUERY
    query_end = (resp.data.query_end)  // DEFINE O FINAL DA PRÓXIMA SUBQUERY

    produtos_novo = produtos_novo.concat(resp.data.data)  // ADICIONA OS 6 PRODUTOS DA BUSCA NOS ANTERIORES

    setProdutos(produtos_novo)  // DEFINE O ESTADO DOS PRODUTOS COM AS NOVAS INFORMAÇÕES

    return [query_start, query_end, produtos_novo]
  }

  async function carrinho_de_compras(){  // FUNÇÃO QUE BUSCA OS ITENS DO CARRINHO DE COMPRAS
    // FUNÇÃO CHAMADA PELA FUNÇÃO 'search_produtos' DESTA PÁGINA

    if(sessionStorage['login']){  // SE O USUARIO ESTIVER LOGADO
      if(!sessionStorage['login'].includes('/')){  // E NÃO ESTIVER LOGADO COMO FRANQUEADO

        var resp = await api.post('buscar_interesses',{  // BUSCA NO DB OS PRODUTOS QUE ESTÃO NO CARRINHO E OS PRODUTOS FAVORITADOS
          "usuario": sessionStorage['login'],
          "loja": sessionStorage['loja'],
        }).then((response) => {
          return response
        })  
        // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
          // 'fav' -> VAZIO POIS NADA ESTÁ FAVORITADO A PEDIDO DO DEPARTAMENTO DE MARKETING
          
          // 'car' -> LISTA COM OS PRODUTOS NO CARRINHO
              // CADA ITEM DE 'car' É UM DICIONÁRIO COM AS CHAVES
              // 'id' -> STRING COM O ID DO PRODUTO
              // id -> DICIONÁRIO COM OS DETALHES DO PRODUTO COM AS CHAVES
                // 'carrinho' -> INT COM A QUANTIDADE DE ITENS DESSE PRODUTO NO CARRINHO
                // 'estoque' -> INT COM QUANTOS PRODUTOS AINDA RESTAM EM ESTOQUE
                // 'img' -> STRING COM A URL DA IMAGEM DO PRODUTO
                // 'preco' -> FLOAT COM O PREÇO UNITÁRIO DO PRODUTO
          
          // 'session' -> STRING COM O ID DA SESSÃO GERADA PELA PAGSEGURO PARA REALIZAR A TRANSAÇÃO        
        
        if(resp){  // CASO EXISTAM PRODUTOS NO CARRINHO SALVOS NO DB
          setFavoritos(resp['data']['fav'])  // DEFINE OS ESTADOS DE CARRINHO E FAVORITOS
          setCarrinho(resp['data']['car']) 
          var produtoscarrinho = []
          for(var i = 0; i < resp['data']['car'].length; i++){  // ADICIONA AS INFORMAÇÕES NA LISTA DE IDS DE PRODUTOS NO CARRINHO
            produtoscarrinho.push(resp['data']['car'][i]['id'])
          }
          
          setProdscarrinho(produtoscarrinho)  // DEFINE O ESTADO DE IDS NO CARRINHO COM AS INFORMAÇÕES NOVAS

          var sessao = []  // COLOCAR NA SESSÃO OS PRODUTOS NO CARRINHO ENCONTRADOS NO DB
          resp['data']['car'].forEach(function (element){
            var item = JSON.stringify(element)
            sessao.push(item)
          })
          sessionStorage['comprar'] = sessao.join(';')  // NOTA -> SEPARADOS POR ;

        }
        else{  // CASO NÃO EXISTAM PRODUTOS SALVOS NO DB
          setProdscarrinho([])  // DEFINE TODOS OS ESTADOS COMO VAZIO
          setFavoritos([])
          setCarrinho([])
        }        
        
      }

      console.log(resp)
    }
    else{  // CASO O USUÁRIO NÃO ESTEJA LOGADO
      var carrinho_list = []
      var prods_carrinho = []

      if(sessionStorage['comprar']){  // VERIFICA SE EXISTE ALGUM PRODUTO NO CARRINHO NA SESSAO
        sessionStorage['comprar'].split(';').forEach(function (element){
          var item = JSON.parse(element)
          carrinho_list.push(item)
          prods_carrinho.push(item['id'])
        })

        setCarrinho(carrinho_list)  // DEFINE O ESTADO DO CARRINHO COM OS PRODUTOS ENCONTRADOS
        setProdscarrinho(prods_carrinho)  // DEFINE O ESTADO DOS IDS COM OS PRODUTOS ENCONTRADOS
      }
      else{  // CASO NÃO ENCONTRE NADA NA SESSÃO
        setCarrinho([])  // DEFINE OS ESTADOS COMO VAZIO
        setProdscarrinho([])
      }
    }
  }
      

  // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
    // 'FiltroBotao' -> BOTÃO QUE ABRE A ABA LATERAL ESQUERDA COM OSS FILTROS
    // 'Header' -> HEADER DA APLICAÇÃO
    // 'Filtro' -> ABA LATERAL ESQUERDA DOS FILTROS
    // 'Loader' -> APARECE ENQUANTO OS PRODUTOS NÃO SÃO CARREGADOS
    // 'ItensComprados' -> ABA LATERAL DO CARRINHO
    // 'PrecoPicture' -> CARD COM FOTO, BOTÕES DE DETALHES E COMPRA, DESCRIÇÃO E PREÇO DO PRODUTO

  return (
    <div>
      <FiltroBotao />
      <div>
        <Header callback={search_produtos}/>
      </div>
      
      <Filtro props={grupos} callback={search_produtos}/>

      <div>
          <ItensComprados props={carrinho} callback={carrinho_de_compras} botao={botao}/> 
      </div>

      <div id="todos_os_produtos" class="d-flex flex-wrap justify-content-between px-0 pt-0 start-page custom-container-catalogo align-items-end">
        {produtos.map((block) => (
          <PrecoPicture props={block} favs={favoritos} callback={carrinho_de_compras} car={carrinho} prod_car={prodscarrinho}/>
        ))}
      </div>
      <div className="mb-5 pb-5" id="loader">
        <div class='mb-5'>
          <Loader />
        </div>
      </div>      
    </div>    
  )
}


export default Home;